var exports = {
  "kL": "xfd349460--d7dd73--container",
  "HE": "xfd349460--d7dd73--button-wrapper",
  "aw": "xfd349460--d7dd73--semi-transparent",
  "Sl": "xfd349460--d7dd73--image",
  "W4": "xfd349460--d7dd73--text-wrapper",
};

module.exports = exports;
